"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LavaFlows = void 0;
const Card_1 = require("../Card");
const CardType_1 = require("../CardType");
const SpaceType_1 = require("../../SpaceType");
const TileType_1 = require("../../TileType");
const SelectSpace_1 = require("../../inputs/SelectSpace");
const BoardName_1 = require("../../boards/BoardName");
const CardName_1 = require("../../CardName");
const CardRenderer_1 = require("../render/CardRenderer");
const DeferredAction_1 = require("../../deferredActions/DeferredAction");
const PartyHooks_1 = require("../../turmoil/parties/PartyHooks");
const PartyName_1 = require("../../turmoil/parties/PartyName");
const RedsPolicy_1 = require("../../turmoil/RedsPolicy");
const constants_1 = require("../../constants");
const Units_1 = require("../../Units");
class LavaFlows extends Card_1.Card {
    constructor(name = CardName_1.CardName.LAVA_FLOWS, adjacencyBonus = undefined, metadata = {
        cardNumber: '140',
        renderData: CardRenderer_1.CardRenderer.builder((b) => {
            b.temperature(2).br;
            b.tile(TileType_1.TileType.LAVA_FLOWS, true, false).asterix();
        }),
        description: 'Raise temperature 2 steps and place this tile on a VOLCANIC AREA.',
    }) {
        super({
            cardType: CardType_1.CardType.EVENT,
            name,
            cost: 18,
            adjacencyBonus,
            metadata,
            tr: { temperature: 2 },
        });
    }
    static getVolcanicSpaces(player) {
        const board = player.game.board;
        const boardsWithVolcanicSpaces = [BoardName_1.BoardName.ORIGINAL, BoardName_1.BoardName.ELYSIUM, BoardName_1.BoardName.AMAZONIS, BoardName_1.BoardName.TERRA_CIMMERIA, BoardName_1.BoardName.VASTITAS_BOREALIS];
        const landSpaces = board.getSpaces(SpaceType_1.SpaceType.LAND, player);
        const unoccupiedLandSpaces = landSpaces
            .filter((space) => space.tile === undefined && (space.player === undefined || space.player === player))
            .filter((space) => !space.hasNomads);
        if (boardsWithVolcanicSpaces.includes(player.game.gameOptions.boardName)) {
            return unoccupiedLandSpaces.filter((space) => board.getVolcanicSpaceIds().includes(space.id));
        }
        else {
            return unoccupiedLandSpaces;
        }
    }
    canPlay(player) {
        const game = player.game;
        const volcanicSpaces = LavaFlows.getVolcanicSpaces(player);
        const canPlaceTile = volcanicSpaces.length > 0;
        const trGain = player.computeTerraformRatingBump(this);
        Card_1.Card.setRedsWarningText(player, trGain, this);
        if (PartyHooks_1.PartyHooks.shouldApplyPolicy(player, PartyName_1.PartyName.REDS)) {
            this.reserveUnits = Units_1.Units.adjustUnits(this.reserveUnits, { megacredits: trGain * constants_1.REDS_RULING_POLICY_COST });
            const actionDetails = this.getActionDetails(player, this);
            this.howToAffordReds = RedsPolicy_1.RedsPolicy.canAffordRedsPolicy(player, game, actionDetails);
            if (this.howToAffordReds.mustSpendAtMost !== undefined || this.howToAffordReds.bonusMCFromPlay !== undefined) {
                this.reserveUnits = Units_1.Units.maybeAdjustReservedMegacredits(player, this.reserveUnits, this.howToAffordReds);
            }
            return canPlaceTile && this.howToAffordReds.canAfford;
        }
        else {
            this.howToAffordReds = undefined;
            return canPlaceTile;
        }
    }
    play(player) {
        const game = player.game;
        game.defer(new DeferredAction_1.DeferredAction(player, () => {
            game.increaseTemperature(player, 2);
            return undefined;
        }));
        return new SelectSpace_1.SelectSpace('Select a volcanic area to place this tile on', LavaFlows.getVolcanicSpaces(player), TileType_1.TileType.LAVA_FLOWS, (space) => {
            game.addTile(player, SpaceType_1.SpaceType.LAND, space, { tileType: TileType_1.TileType.LAVA_FLOWS });
            space.adjacency = this.adjacencyBonus;
            return undefined;
        });
    }
    getActionDetails(player, card) {
        const bonusMegaCredits = player.cardIsInEffect(CardName_1.CardName.SUITABLE_INFRASTRUCTURE) && player.willGainHeatProductionFromTemperatureIncrease(2) ? 2 : 0;
        const volcanicSpaces = LavaFlows.getVolcanicSpaces(player);
        return new RedsPolicy_1.ActionDetails({
            card: card,
            temperatureIncrease: 2,
            nonOceanToPlace: TileType_1.TileType.LAVA_FLOWS,
            nonOceanAvailableSpaces: volcanicSpaces,
            bonusMegaCredits: bonusMegaCredits,
        });
    }
}
exports.LavaFlows = LavaFlows;
//# sourceMappingURL=LavaFlows.js.map